import React, { Component } from "react";
import { matchNode } from "../../utils/dom";

export default class DropDown extends Component {
  constructor (props) {
    super(props);
    this.state = { isOpen: false };
    this.onClickHandler = this.onClickHandler.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.isOpen && this.state.isOpen) {
      document.addEventListener("click", this.onClickHandler);
    }

    if (prevState.isOpen && !this.state.isOpen) {
      document.removeEventListener("click", this.onClickHandler);
    }
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.onClickHandler);
  }

  onClickHandler(e) {
    const isInside = matchNode(e.target, this.refs.drop);

    if (!isInside || e.target.tagName === "A") {
      return this.setState({ isOpen: false });
    }

    return null;
  }

  render() {
    return (
      <div className="dropdown">
        <button className="btn btn-xs btn-block" onClick={() => this.setState({isOpen: true})}>{this.props.label}</button>
        <ul ref="drop" className={this.state.isOpen ? "show dropdown-menu" : "hidden dropdown-menu"} >
          {this.props.children}
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Admin/DropDown.jsx